import { Fade } from "@mui/material";
import { connect } from "react-redux";

import CustomTableV2 from "../../common/CustomTableV2";

import { GetInAppNotifications } from "../../redux/notification/actions";

import "./style.css";
import moment from "moment";

function InAppNotification(props) {
    return (
        <div className="main-container" id="in-app-notifications">
            <Fade in={true}>
                <div>
                    <CustomTableV2
                        title="IN APP NOTIFICATIONS"
                        description=""
                        store={props.Notification?.inAppNotifications}
                        table={{
                            headers: [
                                { title: "#" },
                                { title: "User" },
                                { title: "Type" },
                                { title: "Date" },
                                { title: "Shared" },
                            ],
                            body: (iap, i) => {
                                return (
                                    <tr className={i % 2 == 0 ? "tr-even" : ""}>
                                        <td><h5>{i}</h5></td>
                                        <td><h5>{(iap?.first_name + " " + iap?.last_name)?.toUpperCase()}</h5></td>
                                        <td><h5>{iap?.type?.toUpperCase()}</h5></td>
                                        <td><h5>{iap?.date ? moment(iap?.date).format("YYYY-MM-DD") : "-"}</h5></td>
                                        <td><h5>{iap?.date_shared ? moment(iap?.date_shared).format("YYYY-MM-DD") : "-"}</h5></td>
                                    </tr>
                                )
                            }
                        }}

                        actions={{
                            get: (page, count, filter, sort) => {
                                props.GetInAppNotifications(page, count, filter, sort);
                            },
                        }}
                    />
                </div>
            </Fade>
        </div>
    );
}

const mapStateToProps = (state) => ({
    Notification: state.Notification,
})

export default connect(mapStateToProps, {
    GetInAppNotifications,
})(InAppNotification);
